import React from 'react';

import { ReverseTrialLozengeListItemExperiment } from '@confluence/trial-components/entry-points/ReverseTrialListItem';
import { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery';

const supportedItems: Record<string, string> = {
	'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link':
		'confluence_space_settings_automation_list_item',
	'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link':
		'confluence_space_settings_calendars_list_item',
};

type EditionIconProps = {
	completeKey?: string | null;
	href?: string | null;
};

export const EditionIcon = ({ completeKey, href }: EditionIconProps) => {
	if (!completeKey || !supportedItems[completeKey]) {
		return null;
	}

	return (
		<ReverseTrialLozengeListItemExperiment
			touchpointId={supportedItems[completeKey]}
			edition={ConfluenceEdition.PREMIUM}
			href={href}
		/>
	);
};
